var EN_TRANSLATION = {
  "commons.close": "Close",
  "commons.company": "Company",
  "commons.expand": "Expand",
  "commons.internet": "Internet",
  "commons.learnMore": "Learn More",
  "commons.links": "Links",
  "commons.menu.label.compare": "Compare",
  "commons.menu.label.compareAll": "Compare All",
  "commons.menu.label.explore": "Explore",
  "commons.menu.label.new": "New",
  "commons.menu.label.overview": "Overview",
  "commons.social": "Social",
  "commons.store": "Store",
  "commons.support": "Support",
  "commons.tools": "Tools",
  "commons.training": "Training",
  "commons.viewAll": "View All",
  "commons.whatsNew": "What's New",
  "menu.action.label.calculateNow": "Calculate Now",
  "menu.description.cloudGateways": "High-performance, scalable IT and resilient networking suite.",
  "menu.description.integrations": "Innovative connectivity and efficiency solutions.",
  "menu.description.physicalSecurity": "Scalable security seamless UniFi.",
  "menu.description.startHere.caseStudies.celticDoyle": "Discover how Ubiquiti transformed connectivity in hotels, enhancing guest experiences and operational efficiency.",
  "menu.description.startHere.caseStudies.fedexForum": "Learn how Ubiquiti helped enterprises streamline their IT infrastructure, reducing costs and boosting productivity.",
  "menu.description.startHere.caseStudies.fiveGuys": "Explore how Ubiquiti enabled retailers to optimize their networks, improving customer satisfaction and store management.",
  "menu.description.startHere.caseStudies.tinyDino": "Find out how Ubiquiti's robust solutions enhanced connectivity and efficiency in industrial environments.",
  "menu.description.startHere.caseStudies.unifiCaseStudies": "Check out our case studies to see how UniFi’s solutions are transforming businesses.",
  "menu.description.startHere.designCenter.nextAiCamera": "See how Ubiquiti solutions improved network reliability and performance in educational institutions, benefiting students and staff.",
  "menu.description.startHere.designCenter.nextAiCyber": "Discover how Ubiquiti transformed connectivity in hotels, enhancing guest experiences and operational efficiency.",
  "menu.description.startHere.designCenter.sdWanSase": "Learn how Ubiquiti helped enterprises streamline their IT infrastructure, reducing costs and boosting productivity.",
  "menu.description.startHere.designCenter.siteManager": "FedExForum is a premier, multi-purpose indoor arena that's home to the NBA's Memphis Grizzlies. The 800,000 ft² campus seats 18,000 and...",
  "menu.description.startHere.resources.blog": "Discover the latest in networking and IT innovation. Stay updated with product launches, expert insights, and tutorials.",
  "menu.description.startHere.resources.enterpriseProgram": "Learn how Ubiquiti helped enterprises streamline their",
  "menu.description.startHere.resources.eventsPrograms": "Explore how Ubiquiti enabled retailers to optimize their networks, improving customer satisfaction and store management.",
  "menu.description.startHere.resources.techSpecs": "Discover how Ubiquiti transformed connectivity in hotels, enhancing guest experiences and operational efficiency.",
  "menu.description.startHere.resources.training": "FedExForum is a premier, multi-purpose indoor arena that’s home to the NBA’s Memphis Grizzlies. The 800,000 ft² campus seats 18,000 and...",
  "menu.description.startHere.whyUniFi.howItWorks": "Networking, physical security, and more - all unified in an intuitive software interface with scalable, license-free cloud management.",
  "menu.description.startHere.whyUniFi.tcoCalculator": "Networking, physical security, and more – all unified in an intuitive software interface with scalable, license-free cloud management.",
  "menu.description.switching": "Scale-ready with full-feature switching.",
  "menu.description.wifi": "Scalable WiFi 7 for wired-like experience.",
  "menu.label.cloudGateways": "Cloud Gateways",
  "menu.label.cloudGateways.compact": "Compact",
  "menu.label.cloudGateways.compact.description": "Completely plug-and-play<br> with no CloudKey required.",
  "menu.label.cloudGateways.enterpriseScale": "Enterprise Scale",
  "menu.label.cloudGateways.enterpriseScale.description": "Manage 500+ UniFi<br> devices and 5,000+ clients.",
  "menu.label.cloudGateways.identity": "Identity",
  "menu.label.cloudGateways.identity.description": "Simplify user access for<br> your entire network.",
  "menu.label.cloudGateways.largeScale": "Large Scale",
  "menu.label.cloudGateways.largeScale.description": "Professional-grade with<br> UniFi in a single interface.",
  "menu.label.cloudGateways.overview": "Cloud Gateways Overview",
  "menu.label.cloudGateways.overview.description": "Scalable IT and resilient<br> networking suite.",
  "menu.label.cloudGateways.wifiIntegrated": "WiFi Integrated",
  "menu.label.cloudGateways.wifiIntegrated.description": "Complete UniFi networking<br> in a sleek design.",
  "menu.label.cloudGateways.wifiIntegrated.dreamRouter": "Dream Router",
  "menu.label.cloudGateways.wifiIntegrated.dreamWall": "Dream Wall",
  "menu.label.cloudGateways.wifiIntegrated.express": "Express",
  "menu.label.introduction": "Introduction",
  "menu.label.moreFromUi": "More from UI",
  "menu.label.newIntegrations": "Integrations",
  "menu.label.newIntegrations.accessoryTech": "Accessory Tech",
  "menu.label.newIntegrations.accessoryTech.accessories": "Accessories",
  "menu.label.newIntegrations.accessoryTech.cables": "Cabling",
  "menu.label.newIntegrations.accessoryTech.description": "UniFi Deployment<br> Essentials",
  "menu.label.newIntegrations.accessoryTech.installations": "Installations",
  "menu.label.newIntegrations.accessoryTech.rackDesigns": "Rack Designs",
  "menu.label.newIntegrations.accessoryTech.storage": "Storage",
  "menu.label.newIntegrations.digitalSignage": "Digital Signage",
  "menu.label.newIntegrations.digitalSignage.description": "Plug-and-play <br> digital signage.",
  "menu.label.newIntegrations.evCharging": "EV Charging",
  "menu.label.newIntegrations.evCharging.description": "More than just a powerful<br> EV charger.",
  "menu.label.newIntegrations.hosting": "Advanced Hosting",
  "menu.label.newIntegrations.hosting.controlPlaneOptions": "Control Plane Options",
  "menu.label.newIntegrations.hosting.description": "Cloud Keys and<br> Independent Gateways.",
  "menu.label.newIntegrations.hosting.independentGateways": "Independent Gateways",
  "menu.label.newIntegrations.internetSolutions": "Internet Solutions",
  "menu.label.newIntegrations.internetSolutions.cableInternet": "Cable Internet",
  "menu.label.newIntegrations.internetSolutions.description": "Seamless Internet<br> and Failover",
  "menu.label.newIntegrations.internetSolutions.lteBackup": "LTE Backup",
  "menu.label.newIntegrations.managedVoip": "Managed VoIP",
  "menu.label.newIntegrations.managedVoip.description": "A true plug-and-play <br> VoIP solution.",
  "menu.label.newIntegrations.mobileRouting": "LTE/5G Routing",
  "menu.label.newIntegrations.mobileRouting.description": "An all-in-one<br> connectivity hub.",
  "menu.label.newIntegrations.overview": "New Integrations Overview",
  "menu.label.newIntegrations.overview.description": "New Integrations Overview",
  "menu.label.newIntegrations.premiumAudio": "Premium Audio",
  "menu.label.newIntegrations.premiumAudio.description": "Powerful amp for<br> discerning audiophiles.",
  "menu.label.newIntegrations.premiumIoT": "Premium IoT",
  "menu.label.newIntegrations.premiumIoT.description": "Empower spaces through<br> connected IoT solutions.",
  "menu.label.newIntegrations.professionalAV": "Professional A/V",
  "menu.label.newIntegrations.unifiDrive": "NAS",
  "menu.label.newIntegrations.unifiDrive.description": "Lighting-fast private<br> storage.",
  "menu.label.physicalSecurity": "Physical Security",
  "menu.label.physicalSecurity.bullet": "Bullet",
  "menu.label.physicalSecurity.domeTurret": "Dome & Turret",
  "menu.label.physicalSecurity.doorAccess": "Door Access",
  "menu.label.physicalSecurity.overview": "Physical Security Overview",
  "menu.label.physicalSecurity.ptz": "PTZ",
  "menu.label.physicalSecurity.specialDevices": "Special Devices",
  "menu.label.security.bullet": "Bullet",
  "menu.label.security.bullet.description": "Advanced optics in a <br> durable, elegant design.",
  "menu.label.security.domeAndTurret": "Dome & Turret",
  "menu.label.security.domeAndTurret.description": "Worry-free security for <br> large areas.",
  "menu.label.security.doorAccess": "Door Access",
  "menu.label.security.doorAccess.description.1": "Manage effortlessly with UniFi Access",
  "menu.label.security.overview.description": "Scalable security, <br> seamless UniFi.",
  "menu.label.security.ptz": "PTZ",
  "menu.label.security.ptz.description": "Real-time control, even <br> remotely connected.",
  "menu.label.security.specialDevices": "Special Devices",
  "menu.label.security.specialDevices.aiEnhancements": "AI Enhancements",
  "menu.label.security.specialDevices.compactCameras": "Compact Cameras",
  "menu.label.security.specialDevices.description": "Physical security<br> enhanced.",
  "menu.label.security.specialDevices.doorbells": "Doorbells",
  "menu.label.security.specialDevices.floodlight": "Floodlight",
  "menu.label.security.specialDevices.superLink": "SuperLink",
  "menu.label.security.videoRecorders": "Next-Gen NVR",
  "menu.label.security.videoRecorders.description": "Lighting-fast private <br> storage.",
  "menu.label.siteManager": "Site Manager",
  "menu.label.startHere": "Start Here",
  "menu.label.startHere.caseStudies": "Case Studies",
  "menu.label.startHere.caseStudies.featured.celticDoyle": "Celtic & The Doyle Collection",
  "menu.label.startHere.caseStudies.featured.fedexForum": "FedExForum: 18,000-Seat Arena",
  "menu.label.startHere.caseStudies.featured.fiveGuys": "Five Guys: 250+ Restaurant roll-out!",
  "menu.label.startHere.caseStudies.featured.tinyDino": "Tiny Dino Agency",
  "menu.label.startHere.caseStudies.unifiCaseStudies": "UniFi Case Studies",
  "menu.label.startHere.designCenter": "Design Center",
  "menu.label.startHere.designCenter.description": "See how Ubiquiti solutions improved network reliability and performance in educational institutions, benefiting students and staff.",
  "menu.label.startHere.designCenter.nextAiCamera": "NextAI Camera",
  "menu.label.startHere.designCenter.nextAiCyber": "NextAI Cyber",
  "menu.label.startHere.designCenter.sdWanSase": "SD-WAN/SASE",
  "menu.label.startHere.designCenter.siteManager": "Site Manager",
  "menu.label.startHere.knowledgeCenter": "Knowledge Center",
  "menu.label.startHere.knowledgeCenter.largeProjectAssistance": "Large Project Assistance",
  "menu.label.startHere.knowledgeCenter.professionalSupport": "Professional Support",
  "menu.label.startHere.knowledgeCenter.uispCarrierPlatform": "UISP Carrier Platform",
  "menu.label.startHere.partnerHub": "Partner with UniFi",
  "menu.label.startHere.resources": "Resources",
  "menu.label.startHere.resources.blog": "Blog",
  "menu.label.startHere.resources.eventsPrograms": "Events & Programs",
  "menu.label.startHere.resources.proSupport": "Professional Support",
  "menu.label.startHere.resources.techSpecs": "Tech Specs",
  "menu.label.startHere.resources.training": "Training",
  "menu.label.startHere.siteMap": "Site Map",
  "menu.label.startHere.whyUniFi": "How It Works?",
  "menu.label.startHere.whyUniFi.designCenter": "Design Center",
  "menu.label.startHere.whyUniFi.howItWorks.large": "Large",
  "menu.label.startHere.whyUniFi.howItWorks.massiveScale": "Massive-Scale",
  "menu.label.startHere.whyUniFi.howItWorks.multiSite": "Multi-Site",
  "menu.label.startHere.whyUniFi.howItWorks.simple": "Simple",
  "menu.label.startHere.whyUniFi.migrationAssistance": "Migration Assistance",
  "menu.label.storybook.first": "First Item",
  "menu.label.storybook.second": "Second Item",
  "menu.label.storybook.third": "Third Item",
  "menu.label.switching": "Switching",
  "menu.label.switching.compact": "Compact",
  "menu.label.switching.compact.description": "Multi-GbE & <br> Versatile",
  "menu.label.switching.coreAggregation": "Core & Aggregation",
  "menu.label.switching.edge": "Edge",
  "menu.label.switching.enterprise": "Enterprise",
  "menu.label.switching.enterprise.description": "10 GbE & <br> Beyond",
  "menu.label.switching.overview": "Overview",
  "menu.label.switching.overview.description": "Scale-ready with <br> full-feature switching.",
  "menu.label.switching.professional": "Professional",
  "menu.label.switching.professional.description": "2.5/10 GbE & <br> Etherlighting™",
  "menu.label.switching.value": "Value",
  "menu.label.switching.value.description": "GbE, Fanless & <br> Silent Cooling",
  "menu.label.switching.wan": "WAN",
  "menu.label.switching.wan.description": "Designed for<br> High Availability",
  "menu.label.unifi": "UniFi",
  "menu.label.viewSiteMapTopology": "Site Map & Topology",
  "menu.label.wifi": "WiFi",
  "menu.label.wifi.bridging": "Bridging",
  "menu.label.wifi.bridging.buildingBridge": "Building Bridging",
  "menu.label.wifi.bridging.description": "Connect buildings like a <br> wire, without the wire.",
  "menu.label.wifi.bridging.deviceBridge": "Device Bridging",
  "menu.label.wifi.enterprise": "Enterprise",
  "menu.label.wifi.enterprise.description": "All-New UniFi Enterprise<br> WiFi 7 Lineup",
  "menu.label.wifi.flagship": "Flagship",
  "menu.label.wifi.flagship.description": "Ceiling-mounted for <br> highest performance.",
  "menu.label.wifi.megaCapacity": "Mega Capacity",
  "menu.label.wifi.megaCapacity.description": "Service thousands <br> of clients.",
  "menu.label.wifi.outdoor": "Outdoor",
  "menu.label.wifi.outdoor.description": "Versatile deployment into <br> any environment.",
  "menu.label.wifi.overview": "Overview",
  "menu.label.wifi.overview.description": "Scalable WiFi 7 for <br> wired-like experience.",
  "menu.label.wifi.wall": "Wall",
  "menu.label.wifi.wall.description": "Wall-mounted for<br> seamless installation.",
  "menu.old.cloudGateways": "Cloud Gateways",
  "menu.siteMap.closeSiteMap": "Close Full Site Map",
  "menu.siteMap.title": "UniFi Product Site Map",
  "menu.topology.title": "Visual Topology"
};
export { EN_TRANSLATION as default };
//# sourceMappingURL=en.json.mjs.map
